module.exports = __webpack_public_path__ + "img/people-14-min.9cf2464f.png";